import { combineReducers } from 'redux';
import authReducer from './authReducer';
import globalReducer from './globalReducer';

export default combineReducers({
  auth: authReducer,
  global: globalReducer,
});
